export default __webpack_public_path__ + "static/media/acne-vulgaris.6b209420.JPG";